export default __webpack_public_path__ + "assets/img-action-happy-della-avatar2-0f190249.png";